module.exports = __webpack_public_path__ + "img/download_banner.b5062f18.png";